import ToolCategory from "../Page/ToolCategory";
import ToolSubCategory from "../Page/ToolSubCategory";
import Product from "../Page/Product";
import { QuotationPreview } from "../Page/QuotationPreview";
import { Quotation } from "../Page/Quotation";
import { QuotationPDF } from "../Page/QuotationPDF.jsx";
import { Products } from "../Page/Product/Product.jsx";
import { MyProducts } from "../Page/MyProducts/MyProducts.jsx";
import { MultipleQuotationPreview } from "../Page/MultipleQuotationPreview.jsx";
import { EditQuotation } from "../Page/EditQuotation.jsx";

const routes=[
    { path: `${process.env.PUBLIC_URL}/:tool_type`,  access: "view", name: "ToolCategory", element: ToolCategory },
    { path: `${process.env.PUBLIC_URL}/:tool_type/:tool_category`,  access: "view", name: "ToolSubCategory", element: ToolSubCategory },
    { path: `${process.env.PUBLIC_URL}/product/:tool_subcategory`,  access: "view", name: "Product", element: Product },
    { path: `${process.env.PUBLIC_URL}/preview_quotation`,  access: "view", name: "Quotation Preview", element: QuotationPreview },
    { path: `${process.env.PUBLIC_URL}/quotation`,  access: "view", name: "Quotation", element: Quotation },
    { path: `${process.env.PUBLIC_URL}/quotation-pdf`,  access: "view", name: "Quotation", element: QuotationPDF },
    { path: `${process.env.PUBLIC_URL}/edit-quotation`,  access: "view", name: "Quotation", element: EditQuotation },
    { path: `${process.env.PUBLIC_URL}/products`,  access: "view", name: "Product", element: Products },
    { path: `${process.env.PUBLIC_URL}/my_products`,  access: "view", name: "My Product", element: MyProducts },
    { path: `${process.env.PUBLIC_URL}/preview_multiple_quotation`,  access: "view", name: "Multiple Quoatation", element: MultipleQuotationPreview },

];

export default routes; 